import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import logo from '../../assets/images/landing/logo.svg';

export const NewFooter = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    setIsValidEmail(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value));
  };

  return (
    <footer className="bg-white pt-20">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          {/* Logo & Description */}
          <div className="lg:col-span-5">
            <img src={logo} alt="Vero Learning Logo" className="h-16 sm:h-20 mb-4" />
            <p className="text-base font-light sm:text-lg text-black leading-relaxed">
              Vero sees what others miss. Because when you see talent clearly, you don't <br /> just
              hire better- you change what's possible.
            </p>
          </div>

          {/* Company Links */}
          <div className="lg:col-span-3">
            <h4 className="font-bold text-xl mb-6 text-[#0F0F0E]">Company</h4>
            <ul className="space-y-3 text-base font-light text-[#0F0F0E]">
              <li>
                <a href="/contact-us" className="hover:underline">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="/terms-and-conditions" className="hover:underline">
                  Terms and Conditions
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="hover:underline">
                  Privacy Policies
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Services
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="lg:col-span-4">
            <h4 className="font-bold  text-xl mb-4 text-[#0F0F0E]">Join the movement</h4>
            <p className="text-base font-light leading-relaxed mb-4">
              Join the employers and changemakers shaping the future of hiring and get smarter
              hiring ideas—straight to your inbox.
            </p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center bg-cream-200 rounded-3xl md:rounded-full overflow-hidden p-2 mb-4">
              <input
                type="email"
                value={email}
                onChange={handleEmailChange}
                placeholder="Enter your email"
                className="px-4 py-2 bg-transparent w-full sm:w-3/4 outline-none placeholder:text-gray-700"
              />
              <button
                onClick={() => navigate('/signup')}
                disabled={!isValidEmail}
                className={`btn btn-primary !font-normal !px-5 mt-2 sm:mt-0 sm:ml-2 ${
                  !isValidEmail ? 'opacity-50 cursor-not-allowed' : ''
                }`}
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
        <div className="text-center text-black  font-light text-lg  mt-10">
          Secure by design. API and single sign-on integrations available for enterprise clients.
        </div>
      </div>

      <div className="text-center font-light text-sm text-[#0F0F0E] py-5 mt-10 border-t border-gray-200">
        Copyright © {new Date().getFullYear()} verolearning. All rights reserved.
      </div>
    </footer>
  );
};
